import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dq{gap:0.38rem;}.ssr-plugin'
import type { FieldPath, FieldValues } from 'react-hook-form'
import type { CSSProperties } from 'react'
import {
  RadioButtonGroup,
  type RadioButtonGroupOption,
} from '../../radioButton/RadioButtonGroup'
import { FormField } from '../FormField'
import { styled } from 'inlines'
import { Text } from '../../typography/Text'

export type RadioGroupFieldProps<
  T extends FieldValues = FieldValues,
  V extends string = string,
> = {
  name: FieldPath<T>
  options: RadioButtonGroupOption<V>[]
  label?: string
  labelPosition?: 'left' | 'right'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: CSSProperties
  radioButtonStyle?: CSSProperties
}

export const RadioGroupField = <
  T extends FieldValues = FieldValues,
  V extends string = string,
>({
  name,
  label,
  ...groupProps
}: RadioGroupFieldProps<T, V>) => {
  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, errorMessage }) => (
        <div className="d e dq"
        >
          {label && (
            <Text.Medium style={{ color: 'var(--palette-blue-500)' }}>
              {label}
            </Text.Medium>
          )}
          <RadioButtonGroup<V>
            {...groupProps}
            selectedOption={(value as V) ?? undefined}
            onClick={onChange}
          />
          {errorMessage && <Text.FormError>{errorMessage}</Text.FormError>}
        </div>
      )}
    />
  )
}
